import { Injectable } from "@angular/core";

@Injectable({
	providedIn: "root"
})
export class ApiService {
	apiKey = "4C1A02B4-6BB0-4006-9672-7CE7EFED6FC2";
	apiUrl = "https://www.autoflex10.eu/autoflex/servoy-service/velocity/webservice_v2";
}
